import { mapGetters, mapMutations } from "vuex"

export default {
  data() {
    return {
      total_pcs: 0
    }
  },
  methods: {
    ...mapGetters({
      getOrderData: 'getOrderData',
      getSavedItems: 'getSavedItems',
      getNonDraftOrderForms: 'getNonDraftOrderForms',
      getProducts: 'getProducts',
      getShippingVoucher: 'getShippingVoucher',
    }),
    ...mapMutations({
      resetStore: 'resetStore',
      partialReset: 'partialReset',
      setReseting: 'setReseting'
    }),
    getItemLineTotalPrice(product) {
      return this.getVolumeDiscount(product).total
    },
    goToCart() {
      //TODO save current cup state before going to shopping cart
      let uuid = this.$route.params.uuid
      if (uuid == undefined) {
        uuid = this.getOrderData().id
      }
      this.$router.push({
        name: 'Cart',
        params: {
          uuid: uuid
        }
      })
    },
    getProductName(product) {
      if (product.color_name != '') {
        return this.$store.getters.getProductById(product.product).name + ', ' + product.color_name
      }
      return this.$store.getters.getProductById(product.product).name
    },
    getProductMaterialName(material) {
      const materials = {
        "OPT_1": "Valkoinen taivekartonki",
        "OPT_2": "Keltainen kartonki",
        "OPT_3": "Valkoinen barrier kartonki",
      }
      return materials[material]
    },
    getItemThumbnail(item) {
      if (item.color_image) {
        return item.color_image
      }
      if (item.thumbnail_url) {
        return item.thumbnail_url
      }
      return this.$store.getters.getProductById(item.product)?.thumbnail || ''
    },
    resetCart() {
      const answer = window.confirm('Haluatko jatkaa edellisen tilauksen muokkausta vai aloittaa alusta? Mikäli olet ottanut edellisen tilauksen linkin talteen, pääset muokkaamaan sitä linkin kautta.')
      if (!answer) return false

      if (this.$route.name == 'Landing') {
        if (this.$store.getters.getAccountInfo == null) {
          this.resetStore()
        } else {
          this.partialReset()
        }
        this.$router.go() // reload the page
      } else {
        this.setReseting(true)
        this.$router.push({ name: 'Landing' })
      }
    }
  },
  computed: {
    products() {
      if (this.getOrderData() != null && this.getOrderData().items != undefined && this.getOrderData().items) return this.getOrderData().items
      else return []
    },
    has_cups() {
      for (let i = 0; i < this.products.length; i++) {
        console.log(this.products)
        if (this.products[i] != null && this.products[i].resourcetype == 'Cup') {
          return true
        }
      }
      return false
    },
    not_draft_products() {
      if (this.getOrderData() != null) {
        return [...this.getSavedItems()].sort(
          (a, b) => new Date(a.created) - new Date(b.created)
        )
      }
      return []
    },
    non_draft_forms() {
      if (this.getOrderData() != null) return this.getNonDraftOrderForms()
      else return []
    },
    selectedProduct() {
      const id = this.$route.params.item
      return this.products.find(x => x.id === id)
    },
    getVolumeDiscount() {
      // This gives prices from a single product amount
      return item => {
        let productPrices = this.$store.getters.getVolumesDiscount(item.product)
        let cupDiscount = productPrices.find(p => p.volume_point == item.amount)
        if (cupDiscount == undefined) {
          return 100
        }
        return cupDiscount
      }
    },
    getVolumeDiscountPerCupSize() {
      // This gives prices summing up all same products within order
      return (productId, material = '') => {
        let product = this.$store.getters.getProductById(productId)
        if (product.resource_type == 'StoreProduct' || product.resource_type == 'Lid') {
          return product.price
        }

        if (this.$store.getters.getFixedVoucher.product != undefined && this.$store.getters.getFixedVoucher.product === productId) {
          return this.$store.getters.getFixedVoucher.price
        }
        // TODO: with material, we need variant id and send it to next functions
        let productPrices = this.$store.getters.getVolumesDiscount(productId, material)
        let totalAmountProduct = this.$store.getters.getItemsTotalAmountByProduct(productId, material)

        if (productPrices.length == 1) {
          return productPrices[0].price
        }

        // check first volume discount and last one
        if (totalAmountProduct < productPrices[0].volume_point) {
          return productPrices[0].price
        } else if (totalAmountProduct >= productPrices[productPrices.length - 1].volume_point) {
          return productPrices[productPrices.length - 1].price
        }

        // check in between volume discounts
        for (let i = 0; i < productPrices.length; i++) {
          if (productPrices[i].volume_point <= totalAmountProduct && productPrices[i + 1].volume_point > totalAmountProduct) {
            return productPrices[i].price
          }
        }
      }
    },
    getDesignServiceTotalFee() {
      if (this.$store.getters.getDesignServiceFee != undefined) {
        return (this.non_draft_forms.length) * this.$store.getters.getDesignServiceFee.price
      }
      return 0
    },
    getShipping() {
      return this.getShippingVoucher().find(sv =>
        this.not_draft_products.some(item => item.product === sv.product)
      );
    },
    getTotalPrice() {
      let total = 0
      // First non plate products
      this.getProducts().filter(product => product.resource_type != 'Plate').forEach(product => {
        let totalAmountPerProduct = this.$store.getters.getItemsTotalAmountByProduct(product.id)
        if (totalAmountPerProduct > 0) {
          let priceEach = this.getVolumeDiscountPerCupSize(product.id)
          total += totalAmountPerProduct * priceEach
        }
      });
      // Now plate products with their variant id price
      // FIrst we get all materials from non draft plates
      this.getProducts().filter(product => product.resource_type == 'Plate').forEach(product_plate => {
        const materialsPlate = new Set(); // Will contain all materials from an specific plate, for example plate with id 8
        this.not_draft_products.filter(item => {
          if (item.product == product_plate.id) {
            return item
          }
        }).forEach(plate_item => {
          materialsPlate.add(plate_item.material)
        })
        // Now we have all materials in cart from an specific plate
        Array.from(materialsPlate).forEach(material => {
          let totalAmountPerPlateMaterial = this.$store.getters.getItemsTotalAmountByProduct(product_plate.id, material)
          let priceEachMaterial = this.getVolumeDiscountPerCupSize(product_plate.id, material)
          total += totalAmountPerPlateMaterial * priceEachMaterial
        })
      })

      // Add shipping price if needed
      if (this.getShipping) {
        total += this.getShipping.price / 100
      }
      return total.toFixed(2)
    }
  }
}
